import { Injectable } from '@angular/core';

@Injectable()
export abstract class StateService {
  public abstract getUserProfileState(): string;
  public abstract getAccessControllerState(): string;
  public abstract getHelpCenterState(): string;
  public abstract getAfterLoginState(): string;
  public abstract goToCaseHub(): void;
  public abstract goToCaseOverview(caseId: string): void;
  public abstract goToCaseMessaging(caseId: string): void;
}
